import React from "react";
import { FiChevronLeft } from "react-icons/fi";

export default function SidebarCollapseButton({ open, onToggle, controls }) {
  const label = open ? "Contraer menú" : "Expandir menú";
  return (
    <button type="button" className="ops-menu-collapse-handle" onClick={onToggle}
      title={label} aria-label={label} aria-expanded={open} aria-controls={controls}>
      <FiChevronLeft aria-hidden="true" />
    </button>
  );
}
